import React, {
  useState,
  useRef,
  useEffect,
  useContext,
  useCallback,
} from 'react';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import { Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router';
import Header from '../../components/Header';
import MobileNavbar from '../../components/MobileNavbar';
import Modal from '@mui/material/Modal';
// import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Sidebar from '../../components/Sidebar';
import './index.css';
import { AuthContext } from '../../contexts/AuthContext';
import { ChatLoader } from '../../components/ChatLoader';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useHotkeys } from 'react-hotkeys-hook';
import { Socket_URL, subfix_domain } from '../../api';
import toast from 'react-hot-toast';
import {
  get_conversations,
  get_conversation,
  get_messages,
  create_conversation,
  delete_conversation,
} from '../../API/messages';
import { get_user, get_company_user } from '../../API/user';
import { NotificationContext } from '../../contexts/NotificationContext';
import { OutlinedInput } from '@mui/material/OutlinedInput';

export default function Messages({}) {
  const { user, authAxios } = useContext(AuthContext);
  const bottom = useRef(null);

  const [selectedProfile, setSelectedProfile] = useState({ other_user: {} });
  const [text, setText] = useState('');
  const [deleteModal, setDeleteModal] = useState(false);
  const [messageHistory, setMessageHistory] = useState([]);
  const [activeConversations, setActiveConversations] = useState([]);
  console.log('🚀OUTPUT --> activeConversations:', activeConversations);
  const [conversations, setConversations] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMoreMessages, setHasMoreMessages] = useState(false);
  const [conversation, setConversation] = useState(null);
  const [convCreateModal, setConvCreateModal] = useState(false);
  const [phoneModal, setPhoneModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState('');
  const [messageModal, setMessageModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const { customer_id } = useParams();
  const navigate = useNavigate();
  const { messageData, sendJsonMessage } = useContext(NotificationContext);
  const [searchText, setSearchText] = useState('');
  const [unreadMessages, setUnreadMessages] = useState([]);

  // useEffect(() => {
  //   setTimeout(() =>{
  //     authAxios.post(`/api/chats/twilio/test/`, {});
  //   }, 5000)
  // }, [])

  function formatMessageTimestamp(timestamp) {
    const date = new Date(timestamp);
    return date.toLocaleTimeString().slice(0, 5);
  }

  useEffect(() => {
    switch (messageData.type) {
      case 'chat_message_echo':
        setMessageHistory((prev) => prev?.concat(messageData.message));
        setText('');
        break;
      case 'unread_messages':
        setUnreadMessages(messageData.unread_messages);
        setText('');
        break;
      case 'last_50_messages':
        setMessageHistory(messageData.messages.reverse());
        setHasMoreMessages(messageData.has_more);
        break;
      case 'typing':
        updateTyping(messageData);
        break;
      default:
        console.error('Unknown message type!');
        break;
    }
  }, [messageData]);

  // const connectionStatus = {
  //   [ReadyState.CONNECTING]: 'Connecting',
  //   [ReadyState.OPEN]: 'Online',
  //   [ReadyState.CLOSING]: 'Closing',
  //   [ReadyState.CLOSED]: 'Offline',
  //   [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
  // }[readyState];

  const scrollToBottom = () => {
    bottom.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSelectProfile = (profile) => {
    setSelectedProfile(profile);
    scrollToBottom();
    sendJsonMessage({
      type: 'load_messages',
      conversation: profile.name,
    });
  };

  const readProfileMessages = (profile) => {
    sendJsonMessage({
      type: 'read_messages',
      conversation: profile.name,
    });
  };

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (text.length === 0) return;
    if (text.length > 512) return;
    if (!selectedProfile) return;

    sendJsonMessage({
      type: 'chat_message',
      message: text,
      message_type: 'CHAT',
      name: selectedProfile.other_user.username || '',
      direction: 'OUTBOUND',
      conversation: selectedProfile?.name,
    });

    clearTimeout(timeout.current);
    timeoutFunction();
  };

  async function fetchUsers() {
    const res = await get_conversations(authAxios);
    // const res = await authAxios.get("api/customers/");
    const data = res.data
      ?.map((item) => ({
        ...item,
      }))
      .sort(function (a, b) {
        return (
          new Date(b.last_message?.timestamp).getTime() -
          new Date(a.last_message?.timestamp).getTime()
        );
      });
    setConversations(data?.filter((item) => item.other_user) || []);
    setActiveConversations(
      data
        ?.filter((item) => item.other_user)
        ?.sort((a, b) => {
          if (!a.last_message && !b.last_message) return 0;
          if (!a.last_message) return 1;
          if (!b.last_message) return -1;
          return a.last_message.read === b.last_message.read
            ? 0
            : a.last_message.read
            ? 1
            : -1;
        }) || []
      // ?.sort((a, b) =>
      //   a?.last_message?.read === b?.last_message?.read
      //     ? 0
      //     : a?.last_message?.read
      //     ? 1
      //     : -1
      // )
    );
  }

  async function fetchSelectedUser() {
    if (selectedProfile.other_user?.company_user) {
      const res = await get_company_user(
        authAxios,
        selectedProfile.other_user?.company_user.id
      );
      setSelectedUser(res.data);
    } else if (selectedProfile.other_user?.customer) {
      const res = await get_user(
        authAxios,
        selectedProfile.other_user?.customer.id
      );
      // const trips = await get_car_books(
      //   authAxios,
      //   undefined,
      //   selectedProfile.other_user?.customer.id
      // );
      setSelectedUser(res.data);
    }
  }

  async function handleOpenProfile(e) {
    e.preventDefault();
    if (selectedProfile.other_user?.customer) {
      navigate('/user_detail/' + selectedProfile.other_user?.customer.id);
    }
  }

  useEffect(() => {
    fetchUsers();
    fetchSelectedUser();
  }, [selectedProfile, unreadMessages]);

  const getNumberPhone = (phone) => {
    return phone
      ?.replaceAll(' ', '')
      .replaceAll('(', '')
      .replaceAll(')', '')
      .replaceAll('-', '')
      .replace('+', '');
  };

  // useEffect(() => {
  //   async function loadMessages() {
  //     setMessageHistory((prev) => prev.concat(unreadMessages.filter(item => item.conversation === selectedProfile?.id).reverse()));
  //     unreadMessages.forEach(item => {
  //       if (item.conversation === selectedProfile?.id) {
  //         sendJsonMessage({
  //           type: 'load_messages',
  //           conversation: selectedProfile.name
  //         });
  //       }
  //     })
  //   }

  //   loadMessages();
  // }, [unreadMessages]);

  useEffect(() => {
    scrollToBottom();
  }, [messageHistory]);

  async function fetchConversation() {
    const apiRes = await get_conversation(authAxios, selectedProfile?.name);
    if (apiRes.status === 200) {
      const data = apiRes.data;
      setConversation(data);
    }
  }

  useEffect(() => {
    if (selectedProfile.id) fetchConversation();
  }, [selectedProfile.id, user]);

  const inputReference = useHotkeys(
    'enter',
    () => {
      handleSendMessage();
    },
    {
      enableOnTags: ['INPUT'],
    }
  );

  useEffect(() => {
    inputReference.current.focus();
  }, [inputReference]);

  async function fetchMessages() {
    if (!selectedProfile.id) return;
    const apiRes = await get_messages(authAxios, selectedProfile?.name, page);
    if (apiRes.status === 200) {
      const data = await apiRes.data;
      setHasMoreMessages(data.next !== null);
      setPage(page + 1);
      setMessageHistory((prev) => data.results.reverse().concat(prev));
    }
  }

  const [meTyping, setMeTyping] = useState(false);
  const timeout = useRef();

  function timeoutFunction() {
    setMeTyping(false);
    sendJsonMessage({ type: 'typing', typing: false });
  }

  function onType() {
    if (meTyping === false) {
      setMeTyping(true);
      sendJsonMessage({ type: 'typing', typing: true });
      timeout.current = setTimeout(timeoutFunction, 5000);
    } else {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(timeoutFunction, 5000);
    }
  }

  const handleCreateConversation = async () => {
    try {
      const userRes = await get_user(authAxios, customer_id);
      const apiRes = await create_conversation(authAxios, {
        phone: getNumberPhone(userRes.data?.phone),
      });
      if (apiRes.status === 201) {
        toast.success('Successfully created.');
        fetchUsers();
        navigate('/messages');
      }
    } catch (e) {
      toast.error(e.response.data.message);
    }
  };

  const getFormartPhone = (phoneNumberString) => {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = match[1] ? '+1 ' : '';
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    } else return phoneNumberString;
  };

  useEffect(() => () => clearTimeout(timeout.current), []);

  const [typing, setTyping] = useState(false);

  function updateTyping(event) {
    if (event.user !== user?.username) {
      setTyping(event.typing);
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    scrollToBottom();
    setText('');
  }, [selectedProfile]);

  const handleDeleteMessages = async () => {
    if (!selectedProfile.id) return;
    const apiRes = await delete_conversation(authAxios, selectedProfile?.name);
    if (apiRes.status === 204) {
      setDeleteModal(false);
      setHasMoreMessages(false);
      setPage(1);
      setMessageHistory([]);
      fetchUsers();
    }
  };

  useEffect(() => {
    if (customer_id) handleCreateConversation();
  }, [customer_id]);

  const handleSearchChange = (value) => {
    setSearchText(value);
  };

  useEffect(() => {
    setActiveConversations(
      conversations
        .filter(
          (item) =>
            item.other_user?.customer?.name
              ?.toLowerCase()
              .includes(searchText) ||
            getNumberPhone(item.other_user?.customer?.phone)?.includes(
              searchText
            )
        )
        .sort(function (a, b) {
          return (
            new Date(b.last_message?.timestamp).getTime() -
            new Date(a.last_message?.timestamp).getTime()
          );
        })
        ?.sort((a, b) => {
          if (!a.last_message && !b.last_message) return 0;
          if (!a.last_message) return 1;
          if (!b.last_message) return -1;
          return a.last_message.read === b.last_message.read
            ? 0
            : a.last_message.read
            ? 1
            : -1;
        })
      // ?.sort((a, b) =>
      //   a?.last_message?.read === b?.last_message?.read
      //     ? 0
      //     : a?.last_message?.read
      //     ? 1
      //     : -1
      // )
    );
  }, [searchText]);

  return (
    <div className='dashboard page'>
      <Sidebar page='messages' />
      <div className='hero_content'>
        <MobileNavbar />
        <Header />
        <div className='pagewrapper'>
          <div className='booking_wrapper'>
            <div className='booking_header'>
              <h4>Messages</h4>
            </div>
            <div className='messages_container'>
              <div className='messages_sidebar'>
                <div className='messages_sidebar_header'>
                  <div className='message_sidebar_search'>
                    <input
                      type='text'
                      name='message_search'
                      id='message_search'
                      placeholder='Search'
                      value={searchText}
                      onChange={(e) => handleSearchChange(e.target.value)}
                    />
                    <svg
                      width='26'
                      height='26'
                      viewBox='0 0 26 26'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M11.7932 3.64724C13.3576 3.64581 14.8873 4.10841 16.1888 4.97652C17.4903 5.84463 18.505 7.07925 19.1047 8.52418C19.7044 9.96911 19.862 11.5594 19.5577 13.094C19.2533 14.6285 18.5007 16.0383 17.395 17.1451C16.2893 18.2518 14.8802 19.0057 13.3459 19.3114C11.8116 19.6172 10.2212 19.461 8.7757 18.8626C7.33022 18.2643 6.09468 17.2506 5.22538 15.95C4.35608 14.6493 3.89208 13.12 3.89208 11.5556C3.90156 9.46233 4.73682 7.45741 6.21631 5.97657C7.6958 4.49572 9.69995 3.65864 11.7932 3.64724ZM11.7932 2.16669C9.93624 2.16669 8.121 2.71734 6.577 3.749C5.03301 4.78066 3.82961 6.24701 3.11899 7.9626C2.40837 9.6782 2.22243 11.566 2.58471 13.3873C2.94698 15.2085 3.84118 16.8815 5.15424 18.1945C6.4673 19.5076 8.14024 20.4018 9.96151 20.7641C11.7828 21.1263 13.6706 20.9404 15.3862 20.2298C17.1018 19.5192 18.5681 18.3158 19.5998 16.7718C20.6314 15.2278 21.1821 13.4125 21.1821 11.5556C21.1821 9.06549 20.1929 6.67739 18.4321 4.91663C16.6714 3.15587 14.2833 2.16669 11.7932 2.16669Z'
                        fill='#4FC8E9'
                      />
                      <path
                        d='M25.278 24.0428L19.9552 18.6839L18.9297 19.7022L24.2525 25.0611C24.3193 25.1285 24.3988 25.182 24.4863 25.2186C24.5739 25.2552 24.6678 25.2742 24.7627 25.2746C24.8576 25.2749 24.9516 25.2566 25.0394 25.2205C25.1272 25.1845 25.2071 25.1316 25.2744 25.0647C25.3417 24.9979 25.3953 24.9184 25.4319 24.8308C25.4685 24.7433 25.4875 24.6494 25.4879 24.5545C25.4882 24.4596 25.4698 24.3656 25.4338 24.2778C25.3978 24.19 25.3449 24.1101 25.278 24.0428Z'
                        fill='#4FC8E9'
                      />
                    </svg>
                  </div>

                  <div className='clients_row'>
                    <div
                      className='add_client'
                      onClick={() => setConvCreateModal(true)}
                    >
                      <div className='add_client_icon'>
                        <svg
                          width='22'
                          height='22'
                          viewBox='0 0 22 22'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M10.6939 19.672V10.836M10.6939 10.836V2M10.6939 10.836H19.3879M10.6939 10.836H2'
                            stroke='#4FC8E9'
                            strokeWidth='3.26023'
                            strokeLinecap='round'
                          />
                        </svg>
                      </div>
                      Add Client
                    </div>
                    {activeConversations.map((user) => (
                      <div className='client'>
                        <img src='/assets/imgs/other_man.png' alt='client' />
                        {user.other_user?.customer?.name ??
                          user.other_user?.company_user?.name}
                      </div>
                    ))}
                  </div>
                </div>
                <div className='messages_sidebar_body'>
                  <div className='sidebar_body_header'>
                    Message
                    <svg
                      width='15'
                      height='15'
                      viewBox='0 0 15 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      onClick={() => navigate('/notification_history')}
                    >
                      <path
                        d='M10.4565 2.90625L12.0931 4.54211L10.4565 2.90625ZM11.5089 1.46511L7.08352 5.89052C6.85486 6.11886 6.69891 6.40978 6.63534 6.72661L6.22656 8.77279L8.27274 8.36325C8.58956 8.29988 8.88011 8.14457 9.10883 7.91584L13.5342 3.49043C13.6672 3.35745 13.7727 3.19957 13.8447 3.02582C13.9167 2.85207 13.9537 2.66584 13.9537 2.47777C13.9537 2.2897 13.9167 2.10348 13.8447 1.92972C13.7727 1.75597 13.6672 1.5981 13.5342 1.46511C13.4013 1.33213 13.2434 1.22664 13.0696 1.15467C12.8959 1.0827 12.7097 1.04565 12.5216 1.04565C12.3335 1.04565 12.1473 1.0827 11.9735 1.15467C11.7998 1.22664 11.6419 1.33213 11.5089 1.46511V1.46511Z'
                        stroke='#4FC8E9'
                        strokeWidth='1.54545'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M12.4093 10.3181V12.6363C12.4093 13.0462 12.2464 13.4392 11.9566 13.7291C11.6668 14.0189 11.2737 14.1817 10.8638 14.1817H2.36381C1.95393 14.1817 1.56084 14.0189 1.27101 13.7291C0.981184 13.4392 0.818359 13.0462 0.818359 12.6363V4.13627C0.818359 3.72639 0.981184 3.3333 1.27101 3.04347C1.56084 2.75364 1.95393 2.59082 2.36381 2.59082H4.682'
                        stroke='#4FC8E9'
                        strokeWidth='1.54545'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  </div>
                  <div className='client_messages'>
                    {activeConversations.map((user) => (
                      <div
                        key={user.id}
                        className={`client_message  ${
                          selectedProfile?.id === user.id && 'profile_selected'
                        }`}
                        // className={`client_message  profile_selected`}
                        onClick={() => handleSelectProfile(user)}
                      >
                        <div className='profile'>
                          <img
                            src={'/assets/imgs/other_man.png'}
                            alt='client'
                          />
                        </div>
                        <div className='message_body_wrapper'>
                          <div className='message_body'>
                            <div
                              className='title word_wrap'
                              style={{
                                fontWeight:
                                  !user?.last_message?.read &&
                                  user?.last_message
                                    ? 'bold'
                                    : '',
                                fontSize:
                                  !user?.last_message?.read &&
                                  user?.last_message
                                    ? '14px'
                                    : '',
                                color:
                                  !user?.last_message?.read &&
                                  user?.last_message
                                    ? ''
                                    : '#AAAAAA',
                              }}
                            >
                              {user.other_user?.customer?.name ??
                                user.other_user?.company_user?.name}
                              {'  '}{' '}
                              {getFormartPhone(
                                user.other_user?.customer?.phone
                              )}
                            </div>
                            <div className='last_message word_wrap'>
                              <span
                                style={{
                                  fontWeight:
                                    !user?.last_message?.read &&
                                    user?.last_message
                                      ? 'bold'
                                      : '',
                                  fontSize:
                                    !user?.last_message?.read &&
                                    user?.last_message
                                      ? '14px'
                                      : '',
                                  color:
                                    !user?.last_message?.read &&
                                    user?.last_message
                                      ? ''
                                      : '#AAAAAA',
                                }}
                              >
                                {user?.last_message?.content?.length > 70
                                  ? user?.last_message?.content?.slice(0, 70) +
                                    '...'
                                  : user?.last_message?.content}
                              </span>
                            </div>
                          </div>
                          <div
                            className='message_action'
                            onClick={handleOpenProfile}
                          >
                            {!user?.last_message?.read &&
                              user?.last_message && (
                                <svg
                                  height='15'
                                  width='15'
                                  viewBox='0 0 15 15'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <circle
                                    cx='8'
                                    cy='8'
                                    r='4'
                                    stroke='#1da1f2'
                                    stroke-width='3'
                                    fill='#1da1f2'
                                  />
                                </svg>
                              )}
                            <svg
                              width='24'
                              height='24'
                              viewBox='0 0 24 24'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path
                                d='M12 20C11.4696 20 10.9609 19.7893 10.5858 19.4142C10.2107 19.0391 10 18.5304 10 18C10 17.4696 10.2107 16.9609 10.5858 16.5858C10.9609 16.2107 11.4696 16 12 16C12.5304 16 13.0391 16.2107 13.4142 16.5858C13.7893 16.9609 14 17.4696 14 18C14 18.5304 13.7893 19.0391 13.4142 19.4142C13.0391 19.7893 12.5304 20 12 20ZM12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14ZM12 8C11.4696 8 10.9609 7.78929 10.5858 7.41421C10.2107 7.03914 10 6.53043 10 6C10 5.46957 10.2107 4.96086 10.5858 4.58579C10.9609 4.21071 11.4696 4 12 4C12.5304 4 13.0391 4.21071 13.4142 4.58579C13.7893 4.96086 14 5.46957 14 6C14 6.53043 13.7893 7.03914 13.4142 7.41421C13.0391 7.78929 12.5304 8 12 8Z'
                                fill='white'
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className='messages_main'>
                <div className='messages_header'>
                  <div className='messages_header_profile'>
                    <div className='profile'>
                      <img src='/assets/imgs/other_man.png' alt='profile' />
                    </div>
                    <div className='profile_body'>
                      {conversation &&
                        (conversation?.other_user?.customer?.name ??
                          conversation?.other_user?.company_user?.name)}
                      <div className='client_status'>
                        {/* <div className='status_dot'></div> */}
                        {/* {!typing &&
                        conversation &&
                        participants.includes(
                          conversation?.other_user?.username
                        )
                          ? ' online'
                          : ' offline'} */}
                        {typing && (
                          <p className='truncate text-sm text-gray-500'>
                            typing...
                          </p>
                        )}
                      </div>
                    </div>
                    {/* <div><Button variant="outlined" onClick={() => readProfileMessages(selectedProfile)}>Read Messages</Button ></div> */}
                  </div>
                  <div className='profile_actions'>
                    <div
                      className='action voice_call'
                      onClick={() => setPhoneModal(true)}
                    >
                      <svg
                        width='11'
                        height='16'
                        viewBox='0 0 12 16'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M2.09154 0.700516L3.15868 0.379088C3.64446 0.232532 4.16697 0.267766 4.62867 0.478212C5.09038 0.688658 5.45972 1.05993 5.66775 1.52273L6.33182 3.00002C6.51076 3.39798 6.56061 3.84199 6.47437 4.26973C6.38813 4.69747 6.17013 5.08747 5.85097 5.38502L4.69061 6.46695C4.67627 6.48034 4.66451 6.49624 4.6559 6.51387C4.5344 6.76202 4.7189 7.4248 5.29682 8.42637C5.94868 9.55523 6.45204 10.0014 6.6854 9.93259L8.20832 9.46652C8.6254 9.33916 9.07187 9.34549 9.48516 9.48464C9.89846 9.62379 10.2578 9.88877 10.513 10.2424L11.4567 11.5494C11.753 11.9597 11.8902 12.4637 11.8429 12.9676C11.7956 13.4715 11.567 13.9412 11.1995 14.2892L10.3876 15.0574C10.1053 15.3249 9.76241 15.5201 9.38831 15.6263C9.0142 15.7325 8.61994 15.7467 8.23918 15.6675C5.97825 15.1969 3.95261 13.3764 2.1449 10.2457C0.33654 7.11302 -0.227246 4.44516 0.499183 2.25109C0.620783 1.88376 0.829015 1.5511 1.10628 1.28122C1.38355 1.01134 1.72171 0.812159 2.09218 0.700516H2.09154ZM2.37054 1.62366C2.14825 1.69061 1.94533 1.81009 1.77895 1.972C1.61257 2.13391 1.4876 2.33349 1.41461 2.55387C0.788469 4.44452 1.29568 6.84623 2.97997 9.76352C4.66297 12.6789 6.4874 14.3182 8.43525 14.7232C8.66382 14.7707 8.90049 14.7622 9.12506 14.6984C9.34962 14.6346 9.5554 14.5173 9.72482 14.3567L10.5361 13.5892C10.734 13.4018 10.8572 13.1489 10.8828 12.8776C10.9083 12.6062 10.8345 12.3348 10.675 12.1138L9.73125 10.8062C9.5939 10.6158 9.40043 10.4732 9.17794 10.3982C8.95545 10.3233 8.71509 10.3199 8.49054 10.3884L6.96375 10.8557C6.11904 11.1071 5.32447 10.4032 4.46175 8.90787C3.73083 7.64273 3.47754 6.72859 3.78997 6.09023C3.8504 5.9668 3.93268 5.85559 4.03297 5.76173L5.19333 4.6798C5.36525 4.51959 5.48269 4.30956 5.52915 4.0792C5.57562 3.84883 5.54878 3.6097 5.4524 3.39537L4.78832 1.91873C4.67631 1.66947 4.4774 1.4695 4.22873 1.35617C3.98007 1.24284 3.69865 1.22389 3.43704 1.30287L2.3699 1.6243L2.37054 1.62366Z'
                          fill='#8D94BE'
                        />
                      </svg>
                    </div>
                    {/* <div className='action video_call'>
                      <svg
                        width='14'
                        height='12'
                        viewBox='0 0 18 12'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M0 2.625C0 2.02826 0.237053 1.45597 0.65901 1.03401C1.08097 0.612053 1.65326 0.375 2.25 0.375H10.6875C11.2332 0.374936 11.7604 0.573217 12.1708 0.932919C12.5812 1.29262 12.8469 1.78922 12.9184 2.33025L16.4171 0.7755C16.5884 0.699193 16.776 0.666897 16.9629 0.681546C17.1498 0.696196 17.3301 0.757327 17.4874 0.859383C17.6447 0.961439 17.7739 1.10118 17.8635 1.26591C17.953 1.43065 17.9999 1.61514 18 1.80263V10.1974C17.9998 10.3847 17.9529 10.569 17.8634 10.7336C17.774 10.8982 17.6448 11.0379 17.4877 11.1399C17.3306 11.2419 17.1505 11.3031 16.9637 11.3179C16.7769 11.3327 16.5895 11.3006 16.4182 11.2245L12.9184 9.66975C12.8469 10.2108 12.5812 10.7074 12.1708 11.0671C11.7604 11.4268 11.2332 11.6251 10.6875 11.625H2.25C1.65326 11.625 1.08097 11.3879 0.65901 10.966C0.237053 10.544 0 9.97174 0 9.375V2.625ZM12.9375 8.44688L16.875 10.1974V1.80263L12.9375 3.55312V8.44688ZM2.25 1.5C1.95163 1.5 1.66548 1.61853 1.4545 1.82951C1.24353 2.04048 1.125 2.32663 1.125 2.625V9.375C1.125 9.67337 1.24353 9.95952 1.4545 10.1705C1.66548 10.3815 1.95163 10.5 2.25 10.5H10.6875C10.9859 10.5 11.272 10.3815 11.483 10.1705C11.694 9.95952 11.8125 9.67337 11.8125 9.375V2.625C11.8125 2.32663 11.694 2.04048 11.483 1.82951C11.272 1.61853 10.9859 1.5 10.6875 1.5H2.25Z'
                          fill='#8D94BE'
                        />
                      </svg>
                    </div> */}
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        setDeleteModal(true);
                      }}
                      className='action delete'
                    >
                      <svg
                        width='14'
                        height='16'
                        viewBox='0 0 14 16'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M8.35 2.59961C8.35 2.24157 8.20777 1.89819 7.95459 1.64502C7.70142 1.39184 7.35804 1.24961 7 1.24961C6.64196 1.24961 6.29858 1.39184 6.04541 1.64502C5.79223 1.89819 5.65 2.24157 5.65 2.59961H4.75C4.75 2.00287 4.98705 1.43058 5.40901 1.00862C5.83097 0.586662 6.40326 0.349609 7 0.349609C7.59674 0.349609 8.16903 0.586662 8.59099 1.00862C9.01295 1.43058 9.25 2.00287 9.25 2.59961H13.3C13.4193 2.59961 13.5338 2.64702 13.6182 2.73141C13.7026 2.8158 13.75 2.93026 13.75 3.04961C13.75 3.16896 13.7026 3.28342 13.6182 3.36781C13.5338 3.4522 13.4193 3.49961 13.3 3.49961H12.8014L11.635 13.6066C11.5842 14.0453 11.374 14.45 11.0442 14.7437C10.7145 15.0374 10.2883 15.1997 9.8467 15.1996H4.1533C3.71171 15.1997 3.28551 15.0374 2.95578 14.7437C2.62604 14.45 2.41578 14.0453 2.365 13.6066L1.1977 3.49961H0.7C0.594677 3.49964 0.492678 3.46273 0.411767 3.39531C0.330856 3.32788 0.276158 3.23421 0.2572 3.13061L0.25 3.04961C0.25 2.93026 0.297411 2.8158 0.381802 2.73141C0.466193 2.64702 0.580653 2.59961 0.7 2.59961H8.35ZM11.8942 3.49961H2.1049L3.2587 13.5031C3.2841 13.7225 3.38929 13.9249 3.55426 14.0718C3.71922 14.2187 3.93243 14.2998 4.1533 14.2996H9.8467C10.0674 14.2995 10.2804 14.2183 10.4452 14.0715C10.61 13.9246 10.715 13.7224 10.7404 13.5031L11.8942 3.49961ZM5.65 5.74961C5.8705 5.74961 6.055 5.88911 6.0928 6.07271L6.1 6.14381V11.6563C6.1 11.8732 5.8984 12.0496 5.65 12.0496C5.4295 12.0496 5.245 11.9101 5.2072 11.7265L5.2 11.6554V6.14471C5.2 5.92691 5.4016 5.75051 5.65 5.75051V5.74961ZM8.35 5.74961C8.5705 5.74961 8.755 5.88911 8.7928 6.07271L8.8 6.14381V11.6563C8.8 11.8732 8.5984 12.0496 8.35 12.0496C8.1295 12.0496 7.945 11.9101 7.9072 11.7265L7.9 11.6554V6.14471C7.9 5.92691 8.1016 5.75051 8.35 5.75051V5.74961Z'
                          fill='#8D94BE'
                        />
                      </svg>
                    </div>
                    <Modal
                      open={deleteModal}
                      onClose={() => setDeleteModal(false)}
                      aria-labelledby='conf_modal'
                      aria-describedby='modal-modal-description'
                    >
                      <div className='confModal'>
                        <svg
                          width='110'
                          height='110'
                          viewBox='0 0 110 110'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M37.5625 37.5625L72.4375 72.4375M72.4375 37.5625L37.5625 72.4375L72.4375 37.5625Z'
                            stroke='#FF2552'
                            strokeWidth='11.625'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                          <path
                            d='M55 103.438C81.7513 103.438 103.438 81.7513 103.438 55C103.438 28.2487 81.7513 6.5625 55 6.5625C28.2487 6.5625 6.5625 28.2487 6.5625 55C6.5625 81.7513 28.2487 103.438 55 103.438Z'
                            stroke='#FF2552'
                            strokeWidth='11.625'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </svg>{' '}
                        <br />
                        <h4>Are You Sure?</h4>
                        <p>
                          Do you really want to delete this info. This process
                          cannot be undone.
                        </p>
                        <div className='btns'>
                          <button
                            onClick={() => setDeleteModal(false)}
                            className='secondary'
                          >
                            Cancel
                          </button>
                          <button
                            className='primary'
                            onClick={handleDeleteMessages}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </Modal>
                  </div>
                </div>
                <div className='messages_main_body'>
                  {/* Put the scroll bar always on the bottom */}
                  <InfiniteScroll
                    dataLength={messageHistory.length}
                    next={fetchMessages}
                    className='flex flex-col-reverse' // To put endMessage and loader to the top
                    inverse={true}
                    hasMore={hasMoreMessages}
                    loader={<ChatLoader />}
                    scrollableTarget='scrollableDiv'
                  ></InfiniteScroll>
                  <div className='messages'>
                    {messageHistory.map((message) => (
                      <div
                        key={message.id}
                        className={`message ${
                          message.direction === 'OUTBOUND'
                            ? 'message_send'
                            : message.direction === 'INBOUND'
                            ? 'message_receive'
                            : null
                        }`}
                        onClick={() => {
                          setSelectedMessage(message);
                          setMessageModal(true);
                        }}
                      >
                        <div className='message_container'>
                          <div className='message_body word_wrap'>
                            {message.content}
                          </div>
                          <div className='message_meta_data'>
                            <div className='time'>
                              {formatMessageTimestamp(message.timestamp)}
                            </div>
                            <div className='message_profile'>
                              <img
                                src={
                                  message.direction === 'OUTBOUND'
                                    ? '/assets/imgs/profile.png'
                                    : '/assets/imgs/other_man.png'
                                }
                                alt='profile'
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className='bottom' ref={bottom}></div>
                  </div>
                </div>
                <form
                  onSubmit={(e) => handleSendMessage(e)}
                  className='messages_main_footer'
                >
                  <textarea
                    required
                    type='text_field'
                    name='text_field'
                    id='text_field'
                    value={text}
                    style={{ height: '50px' }}
                    placeholder='Type here....'
                    ref={inputReference}
                    onChange={(e) => {
                      setText(e.target.value);
                      onType();
                    }}
                  />
                  <div className='messages_text_actions'>
                    {/* <div className='text_action microphone'>
                      <svg
                        width='14'
                        height='19'
                        viewBox='0 0 14 19'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M7 12C8.66 12 9.99 10.66 9.99 9L10 3C10 1.34 8.66 0 7 0C5.34 0 4 1.34 4 3V9C4 10.66 5.34 12 7 12ZM12.3 9C12.3 12 9.76 14.1 7 14.1C4.24 14.1 1.7 12 1.7 9H0C0 12.42 2.72 15.23 6 15.72V19H8V15.72C11.28 15.24 14 12.42 14 9H12.3Z'
                          fill='#8D94BE'
                        />
                      </svg>
                    </div>
                    <div className='text_action emojis'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M12 1.99805C17.524 1.99805 22.002 6.47605 22.002 12C22.002 17.523 17.524 22 12 22C6.47605 22.001 1.99805 17.523 1.99805 12C1.99805 6.47605 6.47605 1.99805 12 1.99805ZM12 3.49805C10.8759 3.48585 9.76041 3.69675 8.71826 4.11852C7.67612 4.54029 6.72798 5.16457 5.92871 5.95521C5.12944 6.74586 4.49492 7.68718 4.06187 8.72469C3.62882 9.7622 3.40584 10.8753 3.40584 11.9995C3.40584 13.1238 3.62882 14.2369 4.06187 15.2744C4.49492 16.3119 5.12944 17.2532 5.92871 18.0439C6.72798 18.8345 7.67612 19.4588 8.71826 19.8806C9.76041 20.3023 10.8759 20.5132 12 20.501C14.2388 20.4768 16.3776 19.5704 17.9522 17.9787C19.5267 16.387 20.4098 14.2384 20.4098 11.9995C20.4098 9.76065 19.5267 7.61211 17.9522 6.02041C16.3776 4.42871 14.2388 3.52233 12 3.49805ZM8.46205 14.783C8.88295 15.3188 9.42021 15.7518 10.0332 16.0493C10.6461 16.3468 11.3187 16.5009 12 16.5C12.6806 16.5009 13.3525 16.347 13.9649 16.0501C14.5773 15.7532 15.1142 15.3209 15.535 14.786C15.5961 14.7088 15.6718 14.6443 15.7578 14.5962C15.8438 14.5482 15.9384 14.5176 16.0362 14.5061C16.134 14.4946 16.2332 14.5026 16.3279 14.5294C16.4227 14.5562 16.5113 14.6015 16.5885 14.6625C16.6658 14.7236 16.7303 14.7993 16.7784 14.8853C16.8264 14.9713 16.857 15.0659 16.8685 15.1637C16.8799 15.2615 16.872 15.3607 16.8452 15.4554C16.8184 15.5502 16.7731 15.6388 16.712 15.716C16.1508 16.4286 15.435 17.0045 14.6188 17.4001C13.8025 17.7958 12.9071 18.0009 12 18C11.0918 18.0008 10.1953 17.795 9.37826 17.3983C8.56124 17.0016 7.84512 16.4243 7.28405 15.71C7.22048 15.633 7.17295 15.544 7.14425 15.4483C7.11555 15.3526 7.10626 15.2521 7.11692 15.1528C7.12758 15.0534 7.15799 14.9572 7.20634 14.8698C7.2547 14.7824 7.32004 14.7055 7.39852 14.6437C7.477 14.5819 7.56704 14.5363 7.66336 14.5098C7.75967 14.4832 7.86032 14.4762 7.95939 14.4891C8.05847 14.502 8.15396 14.5345 8.24028 14.5848C8.3266 14.6352 8.402 14.7022 8.46205 14.782V14.783ZM9.00005 8.75005C9.16711 8.74532 9.33342 8.77414 9.48915 8.83481C9.64487 8.89548 9.78686 8.98676 9.90669 9.10325C10.0265 9.21975 10.1218 9.35909 10.1868 9.51304C10.2519 9.66699 10.2854 9.83242 10.2854 9.99955C10.2854 10.1667 10.2519 10.3321 10.1868 10.4861C10.1218 10.64 10.0265 10.7793 9.90669 10.8958C9.78686 11.0123 9.64487 11.1036 9.48915 11.1643C9.33342 11.225 9.16711 11.2538 9.00005 11.249C8.67478 11.2398 8.36592 11.1042 8.1391 10.8708C7.91229 10.6375 7.7854 10.3249 7.7854 9.99955C7.7854 9.67415 7.91229 9.36157 8.1391 9.12825C8.36592 8.89493 8.67478 8.75925 9.00005 8.75005ZM15 8.75005C15.1671 8.74532 15.3334 8.77414 15.4891 8.83481C15.6449 8.89548 15.7869 8.98676 15.9067 9.10325C16.0265 9.21975 16.1218 9.35909 16.1868 9.51304C16.2519 9.66699 16.2854 9.83242 16.2854 9.99955C16.2854 10.1667 16.2519 10.3321 16.1868 10.4861C16.1218 10.64 16.0265 10.7793 15.9067 10.8958C15.7869 11.0123 15.6449 11.1036 15.4891 11.1643C15.3334 11.225 15.1671 11.2538 15 11.249C14.6748 11.2398 14.3659 11.1042 14.1391 10.8708C13.9123 10.6375 13.7854 10.3249 13.7854 9.99955C13.7854 9.67415 13.9123 9.36157 14.1391 9.12825C14.3659 8.89493 14.6748 8.75925 15 8.75005Z'
                          fill='#8D94BE'
                        />
                      </svg>
                    </div>
                    <div className='text_action link'>
                      <svg
                        width='22'
                        height='23'
                        viewBox='0 0 22 23'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M1 12.2646L10.4555 2.80911C11.6139 1.65073 13.185 0.999963 14.8232 0.999963C16.4614 0.999963 18.0325 1.65073 19.1909 2.80911C20.3492 3.96748 21 5.53857 21 7.17676C21 8.81495 20.3492 10.386 19.1909 11.5444L9.73531 21C8.96306 21.7722 7.91567 22.2061 6.82354 22.2061C5.73142 22.2061 4.68402 21.7722 3.91177 21C3.13952 20.2277 2.70568 19.1803 2.70568 18.0882C2.70568 16.9961 3.13952 15.9487 3.91177 15.1764L13.3776 5.72088C13.5688 5.52969 13.7958 5.37803 14.0456 5.27456C14.2954 5.17109 14.5631 5.11783 14.8335 5.11783C15.1039 5.11783 15.3716 5.17109 15.6214 5.27456C15.8712 5.37803 16.0982 5.52969 16.2894 5.72088C16.4806 5.91207 16.6322 6.13904 16.7357 6.38884C16.8392 6.63864 16.8924 6.90638 16.8924 7.17676C16.8924 7.44715 16.8392 7.71488 16.7357 7.96468C16.6322 8.21448 16.4806 8.44146 16.2894 8.63265L7.55406 17.3577'
                          stroke='#8D94BE'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                    </div> */}
                    <button type='submit' className='text_action send'>
                      Send
                      <svg
                        width='15'
                        version='1.1'
                        id='Layer_1'
                        x='0px'
                        y='0px'
                        viewBox='0 0 491.022 491.022'
                        xmlSpace='preserve'
                      >
                        <g>
                          <g>
                            <path
                              fill='#fff'
                              d='M490.916,13.991c-0.213-1.173-0.64-2.347-1.28-3.307c-0.107-0.213-0.213-0.533-0.32-0.747 c-0.107-0.213-0.32-0.32-0.533-0.533c-0.427-0.533-0.96-1.067-1.493-1.493c-0.427-0.32-0.853-0.64-1.28-0.96 c-0.213-0.107-0.32-0.32-0.533-0.427c-0.32-0.107-0.747-0.32-1.173-0.427c-0.533-0.213-1.067-0.427-1.6-0.533 c-0.64-0.107-1.28-0.213-1.92-0.213c-0.533,0-1.067,0-1.6,0c-0.747,0.107-1.493,0.32-2.133,0.533 c-0.32,0.107-0.747,0.107-1.067,0.213L6.436,209.085c-5.44,2.347-7.893,8.64-5.547,14.08c1.067,2.347,2.88,4.373,5.227,5.44 l175.36,82.453v163.947c0,5.867,4.8,10.667,10.667,10.667c3.733,0,7.147-1.92,9.067-5.12l74.133-120.533l114.56,60.373 c5.227,2.773,11.627,0.747,14.4-4.48c0.427-0.853,0.747-1.813,0.96-2.667l85.547-394.987c0-0.213,0-0.427,0-0.64 c0.107-0.64,0.107-1.173,0.213-1.707C491.022,15.271,491.022,14.631,490.916,13.991z M190.009,291.324L36.836,219.218 L433.209,48.124L190.009,291.324z M202.809,437.138V321.831l53.653,28.267L202.809,437.138z M387.449,394.898l-100.8-53.013 l-18.133-11.2l-0.747,1.28l-57.707-30.4L462.116,49.298L387.449,394.898z'
                            />
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <Modal
          open={convCreateModal}
          onClose={() => setConvCreateModal(false)}
          aria-labelledby='conf_modal'
          aria-describedby='modal-modal-description'
        >
          <div className='editModal message_add_client_modal'>
            <div className='editModal_header'>
              <h5>Client</h5>
              <div
                onClick={() => setConvCreateModal(false)}
                className='editModal_close'
              >
                <svg
                  width='25'
                  height='25'
                  viewBox='0 0 110 110'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M37.5625 37.5625L72.4375 72.4375M72.4375 37.5625L37.5625 72.4375L72.4375 37.5625Z'
                    stroke='#FF2552'
                    strokeWidth='11.625'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M55 103.438C81.7513 103.438 103.438 81.7513 103.438 55C103.438 28.2487 81.7513 6.5625 55 6.5625C28.2487 6.5625 6.5625 28.2487 6.5625 55C6.5625 81.7513 28.2487 103.438 55 103.438Z'
                    stroke='#FF2552'
                    strokeWidth='11.625'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
            </div>
            <div className='radio_wrapper'>
              <div className='radio' style={{ position: 'relative' }}>
                <input
                  hidden
                  type='radio'
                  name='person_type'
                  onChange={(e) => e.target.value}
                  id='previous_customer'
                />
                <label htmlFor='previous_customer' className='radio_label'>
                  <Button
                    required
                    className='user_upload_btn radio_btn'
                    variant='contained'
                    component={Link}
                    to='/all_users/messages'
                  >
                    <svg viewBox='0 0 76 76' fill='none'>
                      <circle cx='38' cy='38' r='38' fill='#1C2038' />
                      <path
                        d='M38.5004 20.625C39.2463 20.625 39.9616 20.9213 40.4891 21.4488C41.0165 21.9762 41.3129 22.6916 41.3129 23.4375C41.3129 24.1834 41.0165 24.8988 40.4891 25.4262C39.9616 25.9537 39.2463 26.25 38.5004 26.25C37.7544 26.25 37.0391 25.9537 36.5116 25.4262C35.9842 24.8988 35.6879 24.1834 35.6879 23.4375C35.6879 22.6916 35.9842 21.9762 36.5116 21.4488C37.0391 20.9213 37.7544 20.625 38.5004 20.625ZM38.5004 17.8125C37.0085 17.8125 35.5778 18.4051 34.5229 19.46C33.468 20.5149 32.8754 21.9457 32.8754 23.4375C32.8754 24.9293 33.468 26.3601 34.5229 27.415C35.5778 28.4699 37.0085 29.0625 38.5004 29.0625C39.9922 29.0625 41.4229 28.4699 42.4778 27.415C43.5327 26.3601 44.1254 24.9293 44.1254 23.4375C44.1254 21.9457 43.5327 20.5149 42.4778 19.46C41.4229 18.4051 39.9922 17.8125 38.5004 17.8125ZM41.9597 30.4406H35.041C33.7207 30.4406 32.4545 30.9651 31.5209 31.8987C30.5873 32.8323 30.0629 34.0985 30.0629 35.4188V42.8437C30.0321 43.6253 30.3097 44.3876 30.8359 44.9663C31.362 45.545 32.0944 45.8938 32.8754 45.9375V52.4906C32.8754 53.3857 33.2309 54.2442 33.8639 54.8771C34.4968 55.51 35.3552 55.8656 36.2504 55.8656H40.7504C41.2032 55.8659 41.6514 55.775 42.0684 55.5984C42.4854 55.4218 42.8626 55.1631 43.1775 54.8377C43.4924 54.5123 43.7386 54.1268 43.9015 53.7043C44.0643 53.2817 44.1404 52.8307 44.1254 52.3781V45.9375C44.9063 45.8938 45.6387 45.545 46.1648 44.9663C46.691 44.3876 46.9686 43.6253 46.9379 42.8437V35.4188C46.9379 34.0985 46.4134 32.8323 45.4798 31.8987C44.5462 30.9651 43.28 30.4406 41.9597 30.4406ZM32.8754 43.125V35.4188C32.8716 35.1333 32.925 34.85 33.0325 34.5855C33.14 34.3211 33.2994 34.0809 33.5012 33.879C33.7031 33.6771 33.9433 33.5178 34.2078 33.4103C34.4722 33.3028 34.7555 33.2493 35.041 33.2531H41.9597C42.2452 33.2493 42.5285 33.3028 42.7929 33.4103C43.0574 33.5178 43.2976 33.6771 43.4995 33.879C43.7013 34.0809 43.8607 34.3211 43.9682 34.5855C44.0757 34.85 44.1291 35.1333 44.1254 35.4188V43.125H41.3129V52.4344C41.3129 52.5836 41.2536 52.7266 41.1481 52.8321C41.0426 52.9376 40.8995 52.9969 40.7504 52.9969H36.2504C36.1012 52.9969 35.9581 52.9376 35.8526 52.8321C35.7471 52.7266 35.6879 52.5836 35.6879 52.4344V43.125H32.8754Z'
                        fill='#4FC8E9'
                      />
                    </svg>
                    {'Select Existing Customer'}
                  </Button>
                </label>
              </div>
              <div className='radio'>
                <input
                  hidden
                  type='radio'
                  name='person_type'
                  onChange={(e) => e.target.value}
                  id='add_new_person'
                />
                <label htmlFor='add_new_person' className='radio_label'>
                  <Button
                    required
                    className='user_upload_btn radio_btn'
                    variant='contained'
                    component={Link}
                    to='/add_person'
                  >
                    <svg viewBox='0 0 76 76' fill='none'>
                      <circle cx='38' cy='38' r='38' fill='#1C2038' />
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M46.5023 43.3671H43.6898V48.9921H38.0648V51.8046H43.6898V57.4296H46.5023V51.8046H52.1273V48.9921H46.5023V43.3671ZM34.0036 21.3424C33.6964 21.137 33.3519 20.9942 32.9896 20.922C32.6273 20.8498 32.2543 20.8497 31.8919 20.9216C31.5295 20.9936 31.1849 21.1362 30.8776 21.3413C30.5704 21.5465 30.3066 21.8101 30.1012 22.1172C29.8959 22.4243 29.753 22.7689 29.6808 23.1312C29.6086 23.4935 29.6085 23.8665 29.6804 24.2289C29.7524 24.5912 29.895 24.9359 30.1001 25.2431C30.3053 25.5504 30.5689 25.8142 30.8761 26.0196C31.4963 26.4343 32.2559 26.5857 32.9877 26.4404C33.7195 26.295 34.3637 25.865 34.7784 25.2447C35.1931 24.6245 35.3445 23.8649 35.1992 23.1331C35.0539 22.4012 34.6238 21.7571 34.0036 21.3424ZM29.3151 19.0024C29.929 18.5768 30.6214 18.2777 31.3521 18.1226C32.0828 17.9675 32.837 17.9595 33.5708 18.099C34.3046 18.2385 35.0033 18.5228 35.6261 18.9353C36.2488 19.3477 36.7832 19.8801 37.198 20.5012C37.6128 21.1224 37.8998 21.82 38.0421 22.5533C38.1844 23.2866 38.1792 24.0408 38.0269 24.7721C37.8746 25.5034 37.5781 26.1969 37.1549 26.8124C36.7316 27.4279 36.19 27.9529 35.5617 28.3568C34.3211 29.1422 32.8225 29.4114 31.3861 29.1069C29.9497 28.8024 28.6894 27.9482 27.8742 26.727C27.059 25.5057 26.7537 24.0141 27.0235 22.5708C27.2933 21.1274 28.1167 19.8468 29.3179 19.0024H29.3151ZM28.9804 30.6827H35.8992C37.2195 30.6827 38.4857 31.2072 39.4192 32.1408C40.3528 33.0743 40.8773 34.3405 40.8773 35.6608V37.7421H38.0648V35.6608C38.0686 35.3754 38.0152 35.0921 37.9077 34.8276C37.8002 34.5632 37.6408 34.3229 37.4389 34.1211C37.2371 33.9192 36.9968 33.7598 36.7324 33.6523C36.4679 33.5448 36.1846 33.4914 35.8992 33.4952H28.9804C28.695 33.4914 28.4117 33.5448 28.1472 33.6523C27.8828 33.7598 27.6425 33.9192 27.4407 34.1211C27.2388 34.3229 27.0794 34.5632 26.972 34.8276C26.8645 35.0921 26.811 35.3754 26.8148 35.6608V43.3671H29.6273V52.6764C29.6273 52.8256 29.6866 52.9687 29.7921 53.0742C29.8975 53.1797 30.0406 53.2389 30.1898 53.2389H32.4398V56.1077H30.1898C29.2947 56.1077 28.4363 55.7521 27.8033 55.1192C27.1704 54.4862 26.8148 53.6278 26.8148 52.7327V46.1796C26.0339 46.1359 25.3014 45.7871 24.7753 45.2084C24.2492 44.6297 23.9716 43.8673 24.0023 43.0858V35.6608C24.0023 34.3405 24.5268 33.0743 25.4604 32.1408C26.3939 31.2072 27.6601 30.6827 28.9804 30.6827Z'
                        fill='#4FC8E9'
                      />
                    </svg>
                    Add New Person
                  </Button>
                </label>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={phoneModal}
          onClose={() => setPhoneModal(false)}
          aria-labelledby='conf_modal'
          aria-describedby='modal-modal-description'
        >
          <div className='editModal message_add_client_modal'>
            <div className='editModal_header'>
              <h5>Phone number</h5>
              <div
                onClick={() => setPhoneModal(false)}
                className='editModal_close'
              >
                <svg
                  width='25'
                  height='25'
                  viewBox='0 0 110 110'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M37.5625 37.5625L72.4375 72.4375M72.4375 37.5625L37.5625 72.4375L72.4375 37.5625Z'
                    stroke='#FF2552'
                    strokeWidth='11.625'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M55 103.438C81.7513 103.438 103.438 81.7513 103.438 55C103.438 28.2487 81.7513 6.5625 55 6.5625C28.2487 6.5625 6.5625 28.2487 6.5625 55C6.5625 81.7513 28.2487 103.438 55 103.438Z'
                    stroke='#FF2552'
                    strokeWidth='11.625'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
            </div>
            <form
              action='#'
              onSubmit={(e) => {
                setPhoneModal(false);
              }}
              className='card_details'
            >
              {selectedUser?.phone ? getFormartPhone(selectedUser?.phone) : ''}
            </form>
          </div>
        </Modal>
        {messageModal && (
          <Modal
            open={messageModal}
            onClose={() => setMessageModal(false)}
            aria-labelledby='conf_modal'
            aria-describedby='modal-modal-description'
          >
            <div className='editModal message_add_client_modal'>
              <div className='editModal_header'>
                <h5>Message</h5>
                <div
                  onClick={() => setMessageModal(false)}
                  className='editModal_close'
                >
                  <svg
                    width='25'
                    height='25'
                    viewBox='0 0 110 110'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M37.5625 37.5625L72.4375 72.4375M72.4375 37.5625L37.5625 72.4375L72.4375 37.5625Z'
                      stroke='#FF2552'
                      strokeWidth='11.625'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M55 103.438C81.7513 103.438 103.438 81.7513 103.438 55C103.438 28.2487 81.7513 6.5625 55 6.5625C28.2487 6.5625 6.5625 28.2487 6.5625 55C6.5625 81.7513 28.2487 103.438 55 103.438Z'
                      stroke='#FF2552'
                      strokeWidth='11.625'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                </div>
              </div>
              <form
                action='#'
                onSubmit={(e) => {
                  setMessageModal(false);
                }}
                className='card_details message_modal_form'
              >
                <div>From: {selectedProfile.other_user?.email}</div>
                <div className='word_wrap'>
                  {selectedMessage.content.split(',')[0]}
                </div>
                <div className='word_wrap'>
                  {selectedMessage.content.split(',')[1]}
                </div>
                <div className='word_wrap'>
                  {selectedMessage.content.split(',')[2]}
                </div>
                <div className='word_wrap'>
                  {selectedMessage.content.split(',')[3]}
                </div>
              </form>
            </div>
          </Modal>
        )}
      </div>
    </div>
  );
}
